import { UserId } from '@business/entities/account';
import { ChecklistTemplateResponse } from '@business/entities/checklist';
import { useObservable } from '@core/utils/hooks/rxjs';
import { Session } from '@modules/auth/session';
import React, { memo, useMemo } from 'react';
import { NewTaskBloc } from './NewTaskBloc';
import { useBloc } from '@core/utils/bloc';
import { AddTask } from '@modules/dashboard/DashboardPage/TasksMenu/AddTask';
import { OrgId } from '@business/entities/organization';
import { R } from '@core/utils/r';
import { TaskStatusResponse } from '@business/entities/task_status';

export interface NewTaskProps {
  assignee?: UserId[];
  onCreate?(id: ChecklistTemplateResponse, isChecklist: boolean): void;
  orgId?: OrgId;
  onDone?(): void;
  statuses?: TaskStatusResponse[];
}

export const NewTask = memo((props: NewTaskProps) => {
  const { assignee, orgId, onDone, statuses } = props;
  const bloc = useBloc(NewTaskBloc);
  const users = useObservable(bloc.users$, []);
  const user = useObservable(Session.user$);
  const parentId = useMemo(() => `new-task-div-${R.random(false)}`, []);
  return (
    <div className="mt-3" id={parentId}>
      <AddTask
        users={users}
        bloc={bloc}
        assignee={assignee}
        showTaskForm={true}
        user={user}
        orgId={orgId}
        parentSectionId={parentId}
        onDone={() => onDone && onDone()}
        statuses={statuses}
      />
    </div>
  );
});
